import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import {
  getSupplier,
  resetPassword,
  StatusUpdateHandler,
  exportMerchant,
} from "app/services/memberService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import {
  MdEdit,
  MdAccountBalanceWallet,
  MdVpnKey,
  MdSearch,
  MdRefresh,
} from "react-icons/md";
import { AiOutlineCopy, AiOutlineSetting } from "react-icons/ai";
// import enableEmulate from "config.json";
import { AiFillFileExcel } from "react-icons/ai";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Tooltip from "rc-tooltip";
import config from "config.json";
import moment from "moment";

import { NotificationManager } from "react-notifications";

import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";

const { frontUrl } = config;
const SupplierMemberList = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({
  //   canAdd,
  //   canView,
  //   canEdit,
  //   canDelete,
  // });

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [affiliateId, setAffiliateId] = useState("");

  const [company, setCompany] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [group, setGroup] = useState("");
  const [DistributorId, setDistributorId] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [memId, setMemId] = useState(0);
  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);

  const [searchTrigger, setSearchTrigger] = useState(true);

  const balanceFormatter = (cell, row) => {
    return <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>;
  };

  const securityFormatter = (cell, row) => {
    return (
      <>
        {row.securityBalance ? (
          <span className="text-center">₹ {parseFloat(row).toFixed(2)}</span>
        ) : (
          <span className="text-center">₹ 0.00</span>
        )}
      </>
    );
  };

  const virtualbankHandler = (row) => {
    setSelectedMember(row);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;
      case "affiliateId":
        setAffiliateId(value);
        break;
      // Add cases for other fields...

      case "company":
        setCompany(value);
        break;

      case "firstName":
        setFirstName(value);
        break;

      case "lastName":
        setLastName(value);
        break;

      case "emailId":
        setEmailId(value);
        break;

      case "status":
        setStatus(value);
        break;

      case "city":
        setCity(value);
        break;

      case "state":
        setState(value);
        break;

      case "country":
        setCountry(value);
        break;

      case "group":
        setGroup(value);
        break;

      case "DistributorId":
        setDistributorId(value);
        break;
      default:
        break;
    }
  };

  const handleGlobalFilterChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;

      // Add cases for other fields...
      default:
        break;
    }
  };

  const refreshFilter = async (e) => {
    setAffiliateId("");

    setCompany("");
    setFirstName("");
    setLastName("");
    setEmailId("");
    setStatus("");
    setCity("");
    setState("");
    setCountry("");
    setGroup("");

    setTimeout(async () => {
      await loadMember();
    }, 10);
  };

  const refreshGlobalFilter = async (e) => {
    if (isShowGlobalFilter) {
      setSearch("");
    } else {
      setAffiliateId("");

      setCompany("");
      setFirstName("");
      setLastName("");
      setEmailId("");
      setStatus("");
      setCity("");
      setState("");
      setCountry("");
      setGroup("");
    }
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  const companyFormatter = (cell, row) => {
    return cell.toUpperCase();
  };
  // const emulateHandler = (row) => {
  //   try {
  //     if (window.location) {
  //       const queryStr = window.location.origin;
  //       const url = `${frontUrl}/login?key=${row.userEmulateToken}`;
  //       window.open(url);
  //     }
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  // Add other formatter functions...
  // const emulateFormatter = (cell, row) => {
  //   return (
  //     <button className="btn btn-primary" onClick={() => emulateHandler(row)}>
  //       Emulate
  //     </button>
  //   );
  // };

  const emailFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.emailId}</div>}
      >
        <span style={{ whiteSpace: "nowrap" }}>
          {row.emailId.substring(0, 10)}...
          <AiOutlineCopy
            className="ms-1"
            onClick={async () => {
              if ("clipboard" in navigator) {
                await navigator.clipboard.writeText(row.emailId);
                NotificationManager.success(
                  "Copied successfully ",
                  "Success",
                  5000,
                );
              }
            }}
          />
        </span>
      </Tooltip>
    );
  };
  const activeformatter = (row) => {
    return row === true ? (
      <span className="text-success"> Active</span>
    ) : (
      <span className="text-danger"> Inactive</span>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item>
            <Link
              style={{ width: "100%", textDecoration: "none" }}
              className="btn btn-link"
              to={`/admin/supplier/edit/${row.memId}`}
            >
              <MdEdit
                className="text-primary me-4"
                size={15}
                style={{ marginLeft: "-70%" }}
              ></MdEdit>
              Edit
            </Link>
          </Dropdown.Item>

          {/* <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#virtualbank"
            onClick={() => {
              virtualbankHandler(row);
            }}
          >
            <MdAccountBalanceWallet className="text-primary me-4"></MdAccountBalanceWallet>
            Virtual Bank
          </Dropdown.Item> */}

          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Reset Password `,
                html: `<form autocomplete="off"><span>Member Id - ${row.uniqueIdentity}</span><input type="hidden" id="memberId" value="${row.memId}" />
                        <input id="pwd" placeholder="New Password " class="swal2-input" type="password">
                        <input id="con-pwd" placeholder="Confirm Password " class="swal2-input" type="password"></form>`,

                showCancelButton: true,
                confirmButtonText: "Confirm",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    password: document.getElementById("pwd").value,
                    memberId: document.getElementById("memberId").value,
                  };
                  let conPassword = document.getElementById("con-pwd").value;
                  if (!data.password || !conPassword) {
                    Swal.showValidationMessage(
                      `Passowrd and Confirm Password is required.`,
                    );
                  } else if (data.password !== conPassword) {
                    Swal.showValidationMessage(
                      `Passowrd and Confirm Password does not match.`,
                    );
                    return false;
                  } else if (data.password.length < 6) {
                    Swal.showValidationMessage("Password must be 6 characters");
                  } else {
                    const res = await resetPassword(data);
                    return res;
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      icon: "success",
                    });
                  } else {
                    Swal.fire("Error occured");
                  }
                }
              });
            }}
            href="#"
          >
            <MdVpnKey size={15} className="text-danger me-4"></MdVpnKey> Reset
            Password
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                html: `              
              <h5 class="align-left">Name - ${row.memberFullName}</h5>
              <h5>Company Name - ${row.company}</h5>
    
              <h5>Mobile - ${row.memberMobileNo}</h5>
              <input type="text" id="memId" value=${row.memId} hidden/>
             <div class="row>
             <div class="col-12">
              <select class="form-control w-25 m-auto" id="activeStatus" > <option value="true">Activate </option> 
              <option value="false">Deactivate </option>
              </select></div></div>
              `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Update",
                cancelButtonText: "No",
                preConfirm: async () => {
                  const data = {
                    activeStatus: document.getElementById("activeStatus").value,
                    memId: document.getElementById("memId").value,
                  };

                  if (data.activeStatus) {
                    const res = await StatusUpdateHandler(data);
                    return res;
                  } else {
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      icon: "success",
                      showConfirmButton: false,
                      timer: 2500,
                    });
                    loadMember();
                  } else {
                    Swal.fire({
                      title: "Cancelled!",
                      text: "Permission denied.",
                      type: "error",
                      icon: "error",
                      timer: 1500,
                    });
                  }
                }
              });
            }}
          >
            <AiOutlineSetting
              className="text-primary me-4"
              size={15}
            ></AiOutlineSetting>
            Update Status
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const columns = [
    {
      dataField: "uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return {
          width: "200px",
          textAlign: "center",
        };
      },

      formatter: companyFormatter,
    },

    {
      dataField: "memberFullName",
      text: "Member Name",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "emailId",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: emailFormatter,
    },
    {
      dataField: "memberMobileNo",
      text: "Mobile No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "optionalMobileNo",
      text: "Optional Mobile No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "balance",
      text: "Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "creditLimit",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "blockedBalance",
      text: "Limit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "securityBalance",
      text: "Security Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: securityFormatter,
    },
    {
      dataField: "activeMember",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: activeformatter,
    },
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  // const newColumn = enableEmulate
  //   ? [
  //       {
  //         dataField: "userEmulateToken",
  //         text: "Emulate",
  //         headerStyle: (colum, colIndex) => {
  //           return {
  //             width: "100px",
  //             textAlign: "center",
  //           };
  //         },

  //         formatter: emulateFormatter,
  //       },
  //       ...columns,
  //     ]
  //   : columns;

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const expandRow = {
    onlyOneExpanding: true,
    parentClassName: "bg-light",
    renderer: (row) => (
      <>
        <div className="d-flex m-0 b-row">
          <div className="card me-2 ">
            <div className="card-header text-center">Company Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/company-image.png" alt="" />
              </div>
              <div className="col-9">
                <p className="font-weight-bold m-0">
                  ({row.uniqueIdentity ? row.uniqueIdentity?.toUpperCase() : ""}
                  ) {row.company ? row.company?.toUpperCase() : ""}
                  {row.activeMember ? "(Active)" : "(InActive)"}
                </p>
                {row.websiteName ? `Website:${row.websiteName}` : ""}

                <p className="m-0">
                  {row.companyAddress ? row.companyAddress : ""}
                  {row.stateId ? (row.stateId = "1" ? "WB," : ",") : ""}
                  {row.countryId ? (row.countryId = "1" ? "IN," : ",") : ""} Pin
                  No: {row.pin ? row.pin : ""}
                </p>
                {row.panNo ? <p className="m-0"> PAN NO.: {row.panNo} </p> : ""}
                {row.companyType ? (
                  <p className="m-0"> Type: {row.companyType}</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="card me-2">
            <div className="card-header text-center">
              Contact Person Information
            </div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/Contact-person.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  {row?.memberFirstName?.toUpperCase()}
                  {row?.memberLastName?.toUpperCase()}
                </p>

                <p className="card-text">{row.emailId}</p>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header text-center">Balance Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/money-wallet.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  Balance: {parseFloat(row.balance).toFixed(2)} INR
                </p>

                <p className="card-text">
                  Limit: {parseFloat(row.creditLimit).toFixed(2)} INR
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <></>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <i style={{ cursor: "pointer" }} className="i-Arrow-Down-2"></i>;
      }
      return <i style={{ cursor: "pointer" }} className="i-Arrow-Right-2"></i>;
    },
  };

  const loadMember = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      DistributorId,
    });

    const response = await getSupplier(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const exportMember = async () => {
    const query = queryString.getQueryStringFromObj({
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      group,
      DistributorId,
      memberType: "Merchant",
    });

    const response = await exportMerchant(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_merchant.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadMember();
  }, [page, sizePerPage, searchTrigger, search, isShowGlobalFilter]);

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    setSearchTrigger(!searchTrigger);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await exportMember();
    }, 10);
  };

  return (
    <>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="/admin/supplier/add"
        >
          <i className="i-Add-User text-white me-2"></i> Add Supplier
        </Link>
      )}
      <Helmet>
        <title>Supplier List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Supplier List" }]}></Breadcrumb>

      <div className="d-flex flex-row-reverse mb-2">
        <Button variant="primary" onClick={handleExport} disabled={!dataCount}>
          Export
          <AiFillFileExcel size={15} className="ms-1" />
        </Button>
        <Button
          variant="primary"
          className="mx-2 "
          onClick={refreshGlobalFilter}
        >
          Filter
          <i className="i-Filter-2 ms-1  mt-1" size={15}></i>
        </Button>
      </div>
      <div
        className={isShowGlobalFilter ? "collapse" : "show"}
        id="collapseExample"
      >
        <div className="card card-body rounded border mb-1">
          <div className="row">
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <MdVpnKey />
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="affiliateId"
                  placeholder="AffiliateId"
                  value={affiliateId}
                  // defaultValue={this.state.affiliateId}
                  name="affiliateId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Conference"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="CompanyName"
                  placeholder="Company Name"
                  value={company}
                  name="company"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  placeholder="First Name"
                  value={state.firstName}
                  name="firstName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  placeholder="Last Name"
                  value={lastName}
                  name="lastName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  @
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="emailId"
                  placeholder="Email ID"
                  value={state.emailId}
                  name="emailId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2 ">
              <select
                className="form-control mb-3"
                value={status}
                name="status"
                onChange={handleSearchChanges}
              >
                <option value=""> Select Satus</option>

                <option value="true"> Active</option>
                <option value="false"> InActive</option>
              </select>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="nav-icon i-Business-Mens"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="Group"
                  placeholder="Group"
                  value={group}
                  name="group"
                  onChange={handleSearchChanges}
                  disabled
                />
              </div>
            </div>

            <div className="col-12 col-md-2 d-flex justify-content-center mb-3">
              <button
                className="btn btn-outline-primary me-3"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={refreshFilter}
              >
                <MdRefresh className="mx-2" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            expandRow={expandRow}
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
};

export default SupplierMemberList;
